'use strict';

Object.defineProperty(exports, '__esModule', {
  value: true
});

var slicedToArray = require('../../external/@babel/runtime/helpers/esm/slicedToArray.js');

var React = require('react');

var index = require('../../external/classnames/index.js');

var PropTypes = require('prop-types');

var CardCarousel = require('../CardCarousel/CardCarousel.js');

var CarouselItem = require('../../composites/Carousel/CarouselItem/CarouselItem.js');

function _interopDefault(e) {
  return e && e.__esModule ? e : {
    'default': e
  };
}

var React__default = /*#__PURE__*/_interopDefault(React);

var PropTypes__default = /*#__PURE__*/_interopDefault(PropTypes);

var Gallery = function Gallery(_ref) {
  var images = _ref.images,
      className = _ref.className;

  var _useState = React.useState(false),
      _useState2 = slicedToArray['default'](_useState, 2),
      showModal = _useState2[0],
      setShowModal = _useState2[1];

  var _useState3 = React.useState(1),
      _useState4 = slicedToArray['default'](_useState3, 2),
      currentSlideIndex = _useState4[0],
      setCurrentSlideIndex = _useState4[1];

  React.useEffect(function () {
    setVisibleSlide(currentSlideIndex);
  }, [currentSlideIndex]);
  var galleryClasses = index['default']('lanl-gallery', className);
  var modalClasses = index['default']('lanl-gallery-modal', showModal && 'open');

  var openModal = function openModal(slideIndex) {
    setCurrentSlide(~~slideIndex);
    setShowModal(true);
  };

  var moveSlidesBy = function moveSlidesBy(step) {
    setCurrentSlideIndex(currentSlideIndex + step);
    setVisibleSlide(currentSlideIndex);
  };

  var setCurrentSlide = function setCurrentSlide(slideIndex) {
    setCurrentSlideIndex(slideIndex);
    setVisibleSlide(slideIndex);
  };

  var setVisibleSlide = function setVisibleSlide(slideIndex) {
    var slides = document.getElementsByClassName('modal-slides');

    if (slideIndex > slides.length) {
      setCurrentSlideIndex(1);
    }

    if (slideIndex < 1) {
      setCurrentSlideIndex(slides.length);
    }

    for (var i = 0; i < slides.length; i++) {
      var display = i === currentSlideIndex - 1 ? 'block' : 'none';
      slides[i].style.display = display;
    }
  };

  return /*#__PURE__*/React__default['default'].createElement("div", {
    className: galleryClasses,
    "data-testid": "lanl-gallery"
  }, /*#__PURE__*/React__default['default'].createElement(CardCarousel.CardCarousel, {
    length: images.length,
    cardSizeLg: 600,
    cardSizeSm: 600
  }, images.map(function (_ref2, index) {
    var src = _ref2.src,
        alt = _ref2.alt;
    return /*#__PURE__*/React__default['default'].createElement(CarouselItem.CarouselItem, {
      key: "gallery-carousel-item-".concat(index),
      itemId: index,
      card: true
    }, /*#__PURE__*/React__default['default'].createElement("img", {
      src: src,
      alt: alt,
      onClick: function onClick(e) {
        return openModal(e.currentTarget.getAttribute('data-slide-index'));
      },
      "data-slide-index": index + 1
    }));
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: modalClasses
  }, /*#__PURE__*/React__default['default'].createElement("div", {
    className: "toolbar"
  }, /*#__PURE__*/React__default['default'].createElement("span", {
    className: "close",
    onClick: function onClick() {
      return setShowModal(false);
    }
  }, "\xD7")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "content"
  }, images.map(function (_ref3, index) {
    var src = _ref3.src,
        alt = _ref3.alt,
        caption = _ref3.caption;
    return /*#__PURE__*/React__default['default'].createElement("div", {
      className: "modal-slides",
      key: "modal-slide-".concat(index)
    }, /*#__PURE__*/React__default['default'].createElement("div", {
      className: "slide-number"
    }, "".concat(index + 1, "/").concat(images.length)), /*#__PURE__*/React__default['default'].createElement("img", {
      src: src,
      alt: alt
    }), /*#__PURE__*/React__default['default'].createElement("div", {
      className: "caption-wrapper"
    }, /*#__PURE__*/React__default['default'].createElement("p", null, caption)));
  })), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arrow-left"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: function onClick() {
      moveSlidesBy(-1);
    }
  }, "\u276E")), /*#__PURE__*/React__default['default'].createElement("div", {
    className: "arrow-right"
  }, /*#__PURE__*/React__default['default'].createElement("button", {
    onClick: function onClick() {
      moveSlidesBy(1);
    }
  }, "\u276F"))));
};

Gallery.defaultProps = {
  images: [],
  classNames: ''
};
Gallery.propTypes = {
  images: PropTypes__default['default'].arrayOf(PropTypes__default['default'].shape({
    src: PropTypes__default['default'].string.isRequired,
    alt: PropTypes__default['default'].string,
    caption: PropTypes__default['default'].string
  })).isRequired,
  className: PropTypes__default['default'].string
};
exports.Gallery = Gallery;
exports['default'] = Gallery;